/**
 * Azure regions offered by the New Deployment wizard.
 *
 * Extracted verbatim (same list, same order) from NewDeploymentPage so the
 * WorkWise wizard and the page share a single source. Display names are shown
 * in the UI; the WorkWise API takes the location code (`eastus2`).
 *
 * Node-safe: no `@/` alias, no import.meta (the Vite mock layer imports it).
 */
export const AZURE_REGIONS = [
  'East US', 'East US 2', 'Central US', 'West US', 'West US 2',
  'North Europe', 'West Europe', 'UK South',
  'Canada Central', 'Canada East',
  'Southeast Asia', 'Australia East', 'Japan East', 'Brazil South',
]

/**
 * WorkWise only (revision 3): the shared list plus North Central US, where real
 * WorkWise shared servers live. Every other product keeps AZURE_REGIONS.
 */
export const WORKWISE_ONLY_REGIONS = ['North Central US']
export const WORKWISE_REGIONS = [
  ...AZURE_REGIONS.slice(0, 3),
  ...WORKWISE_ONLY_REGIONS,
  ...AZURE_REGIONS.slice(3),
]

/** "East US 2" -> "eastus2". Matches the location codes Azure uses. */
export function toAzureLocation(displayName: string): string {
  return displayName.trim().toLowerCase().replace(/\s+/g, '')
}

/**
 * "eastus2" -> "East US 2" when the code is known, otherwise the code itself.
 * Only WorkWise rows use it, so it knows the WorkWise regions too.
 */
export function fromAzureLocation(code: string): string {
  const needle = code.trim().toLowerCase()
  return WORKWISE_REGIONS.find((r) => toAzureLocation(r) === needle) ?? code
}
